import React, { useEffect, useRef, useState } from 'react'
import cn from 'classnames'

import { Preloader } from '../Preloader/Preloader'
import { SearchField } from './SearchField/SearchField'
import { FilterSelect } from './FilterSelect/FilterSelect'
import { TextField } from './TextField/TextField'
import { CheckBox } from '../CheckBox/CheckBox'

import { ReactComponent as Trash } from '../../assets/icons/trash.svg'

import Backend from '../../api/backend'
import { BACKEND_PORT, BACKEND_URL } from '../../utils/const'

import './FilterPanel.scss'
import { FilterToggleButton } from './FilterToggleButton/FilterToggleButton'

const SORT_LABELS = [
  'lowest token id',
  'highest token id',
  'lowest price',
  'highest price',
  'lowest bid',
  'highest bid',
  'lowest rank',
  'highest rank',
]

export const FilterPanel = ({
  hide,
  onToggle,
  search,
  searchChange,
  filter,
  filterChange,
  price,
  priceChange,
  sort,
  sortChange,
  checked,
  onCheck,
  onClear,
  disabled,
}) => {
  const [filterConfig, setFilterConfig] = useState({})
  const [filtersHeight, setFiltersHeight] = useState(-1)

  const listRef = useRef()

  useEffect(() => {
    let isMounted = true

    new Backend(BACKEND_URL, BACKEND_PORT).getTraits()
      .then(f => {
        if (isMounted) setFilterConfig(f)
      })
      .catch(console.log)

    return () => isMounted = false
  }, [setFilterConfig])

  const onToggleClick = () => {
    setFiltersHeight(listRef.current.scrollHeight)
    onToggle()
  }

  const buildFilters = config => {
    const list = []

    for (const key in config) {
      list.push(
        <FilterSelect
          key={ key }
          label={ key }
          config={ config[key] }
          selected={ filter[key] }
          onChange={ v => filterChange(key, v) }
        />
      )
    }

    return list
  }

  return (
    <div className={cn( 'filter-panel-container', { disabled } )}>
      {
        filterConfig
        ? (
          <>
            <div className="panel-section">
              <button
                className="clear-button section-title"
                onClick={ onClear }
              >
                <span>
                  CLEAR ALL FILTERS
                </span>
                <Trash />
              </button>
              <SearchField
                placeholder="SEARCH BY ID"
                value={ search }
                onChange={ e => searchChange(e.target.value) }
              />
            </div>
            <div
              className={cn( 'filters-wrapper', { hide: hide } )}
              style={{
                height: filtersHeight > -1
                  ? !hide
                    ? filtersHeight
                    : 0
                  : ''
              }}
            >
              <div ref={ listRef } className="list-wrapper">
                <div className="panel-section">
                  { buildFilters(filterConfig) }
                </div>
                {
                  price
                  && (
                    <div className="panel-section">
                      <h6 className="section-title">
                        PRICE RANGE
                      </h6>
                      <div className="price-row">
                        <TextField
                          type="number"
                          placeholder="MIN"
                          value={ price.min }
                          onChange={ e => priceChange('min', e.target.value) }
                        />
                        <span className="section-title">
                          OR
                        </span>
                        <TextField
                          type="number"
                          placeholder="MAX"
                          value={ price.max }
                          onChange={ e => priceChange('max', e.target.value) }
                        />
                      </div>
                    </div>
                  )
                }
                {
                  checked !== undefined
                  && (
                    <div className="panel-section">
                      <CheckBox
                        label="ONLY HAVE BID"
                        pink
                        checked={ checked }
                        onChange={ onCheck }
                      />
                    </div>
                  )
                }
                <div className="panel-section">
                  <h6 className="section-title">
                    SORT BY
                  </h6>
                  <FilterSelect
                    label={ sort > -1 ? SORT_LABELS[sort] : 'SORT BY' }
                    list={ SORT_LABELS }
                    selected={ sort }
                    onChange={ sortChange }
                  />
                </div>
              </div>
            </div>
            <FilterToggleButton
              label={
                hide
                ? 'SHOW FILTERS'
                : 'HIDE FILTERS'
              }
              state={ hide }
              onClick={ onToggleClick }
            />
          </>
        )
        : <Preloader />
      }
    </div>
  )
}